/**
 * Category API Service
 * Handles all category-related API calls
 */
import apiService from './apiService';
import { getCategoriesByGroupId } from '../utils/examApi';

class CategoryService {
  /**
   * Endpoint base path
   */
  basePath = '/api/category';
  
  /**
   * Get all categories with optional filters
   * @param {Object} params - Filter parameters
   * @param {number} [params.ParentId] - The parent category ID to filter by
   * @param {number} [params.CategoryGroupId] - The category group ID to filter by
   * @param {string} [params.Name] - The name of the category to filter by (partial match)
   * @param {string} [params.Description] - The description of the category to filter by (partial match)
   * @param {boolean} [params.Enabled] - Filter by enabled/disabled status
   * @returns {Promise<Array>} - Array of categories
   */
  async getCategories(params = {}) {
    return apiService.get(this.basePath, params);
  }
  
  /**
   * Get a specific category by ID
   * @param {number} id - The ID of the category to retrieve
   * @returns {Promise<Object>} - The category details
   */
  async getCategoryById(id) {
    return apiService.get(`${this.basePath}/${id}`);
  }
  
  /**
   * Get categories by category group ID
   * @param {number} categoryGroupId - The category group ID to filter by
   * @returns {Promise<Array>} - Array of categories for the specified category group
   */
  async getCategoriesByCategoryGroupId(categoryGroupId) {
    return this.getCategories({ CategoryGroupId: categoryGroupId });
  }
  /**
   * Get categories by group ID using examApi.js with hierarchical structure
   * @param {number} categoryGroupId - The category group ID to filter by
   * @returns {Promise<Array>} - Hierarchical array of categories with parent/child relationships
   */
  async getCategoriesByGroupId(categoryGroupId) {
    return getCategoriesByGroupId(categoryGroupId);
  }
}

// Export singleton instance
export default new CategoryService();
